
































































import '@/assets/scss/pages/dashboard-ecommerce.scss';

import { Component, Watch } from 'vue-property-decorator';
import { HashIcon, LayoutIcon, PlusIcon, UploadCloudIcon } from 'vue-feather-icons';
import {
  AntragsbuchFilter,
  AntragsbuchFilterDto,
  IPolicy,
  IProduct,
  PolicyStatus,
} from 'admiral-core';
import PoliciesOverview from '@/views/pages/policies/PoliciesOverview.vue';
import { PolicyApi } from '@/services/PolicyApi';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import PolicyStatusBadge from '@/components/common/PolicyStatusBadge.vue';
import PolicyStatusProgress from '@/views/pages/policies/PolicyStatusProgress.vue';
import HorizontalPolicyStatusSelect from '@/views/pages/policies/HorizonalPolicyStatusSelect.vue';
import PolicyProductCard from '@/views/pages/policies/PolicyProductCard.vue';
import PolicyStatusSelect from '@/components/common/selects/PolicyStatusSelect.vue';
import CreatePolicyModal from '@/views/pages/policies/CreatePolicyModal.vue';
import ImportPoliciesButton from '@/views/pages/policies/ImportPoliciesButton.vue';
import { PermissionMixin } from '@/mixins/PermissionMixin';
import { Util } from '@/utils/Util';
import BasicStatisticCard from '@/components/common/BasicStatisticCard.vue';
import { FormatMixin } from '@/mixins/FormatMixin';

@Component({
  components: {
    BasicStatisticCard,
    ImportPoliciesButton,
    CreatePolicyModal,
    PolicyStatusSelect,
    PolicyProductCard,
    HorizontalPolicyStatusSelect,
    PolicyStatusProgress,
    PolicyStatusBadge,
    PlusIcon,
    PoliciesOverview,
    HashIcon,
    LayoutIcon,
    UploadCloudIcon,
  },
})
export default class Antragsbuch extends mixins(BaseMixin, PermissionMixin, FormatMixin) {
  policies: IPolicy[] = [];

  isLoading = false;

  async reload() {
    const filter = this.$store.getters[
      `PreferencesModule/getAntragsbuchFilter`
    ] as AntragsbuchFilter;

    await this.loadPolicies(filter as AntragsbuchFilterDto);
  }

  async submitted() {
    await this.reload();
    this.$root.$emit('on-submit-create-policy');
  }

  async mounted() {
    await this.loadPolicies(this.antragsbuchFilter);

    this.$root.$on('change-policy-filter', () => {
      this.loadPolicies(this.antragsbuchFilter);
    });
  }

  get sumValue() {
    return this.policies.reduce((acc, policy) => acc + policy.value, 0);
  }

  get sumJahresNettoBeitrag() {
    let sum = 0;
    this.policies.forEach((policy) => {
      if (policy.jahresNettoBeitrag) {
        sum += Number(policy.jahresNettoBeitrag);
      }
    });
    return sum;
  }

  get sumTypeNew() {
    return this.policies.filter((policy) => policy.type === 'new').length;
  }

  get sumTypeSubstitute() {
    return this.policies.filter((policy) => policy.type === 'substitute').length;
  }

  get sumBonus() {
    let sum = 0;
    this.policies.forEach((policy) => {
      if (policy.antragsbuchData?.bonus) {
        sum += Number(policy.antragsbuchData?.bonus);
      }
    });
    return sum;
  }

  get antragsbuchFilter() {
    return this.$store.getters[`PreferencesModule/getAntragsbuchFilter`];
  }

  @Watch('antragsbuchFilter')
  async onPolicyFilterChange() {
    await this.loadPolicies(this.antragsbuchFilter);
  }

  async loadPolicies(filter?: AntragsbuchFilterDto) {
    try {
      this.isLoading = true;
      this.$Progress.start();

      if (!filter) {
        filter = {
          agency: this.user.agency,
        };
      }

      filter.agency = this.user.agency;

      filter.status = [PolicyStatus.POLICED];

      const policies = await PolicyApi.getPolicies({
        ...filter,
        // @ts-ignore
        users: filter.users?.length > 0 ? filter.users : undefined,
        showDemo: this.$store.getters['PreferencesModule/getShowDemo'],
        withAntragsbuchData: true,
      });

      this.policies = policies.data as IPolicy[];
    } catch (e) {
      this.$toastr.e(
        'Beim Abrufen der Anbahnungen ist etwas schiefgegangen. Wir haben den Fehler erfasst und kümmern uns schnellstmöglich.',
      );
      this.isLoading = false;
      this.$Progress.finish();
      throw e;
    }
    this.isLoading = false;
    this.$Progress.finish();
  }
}
